import { useCallback } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationRequestListByUpdatedDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationRequestList | undefined;
};

export const useReservationListByUpdatedDateQueryData = () => {
	/**
	 * QueryData へ変換
	 */
	const onConvertQueryData = useCallback(
		({ serverData }: Props): Result => ({
			queryData: serverData
				? {
						hotelName: serverData.reservationRequestListByUpdatedDate.hotelName,
						hotelPrefecture: serverData.reservationRequestListByUpdatedDate.hotelPrefecture,
						reservationList: serverData.reservationRequestListByUpdatedDate.reservations,
					}
				: undefined,
		}),
		[],
	);

	return {
		onConvertQueryData,
	};
};
